import React from 'react';
import { Box } from '@mui/material';
import Allgiftcardbanner from "../../../assets/99giftimages/allgiftcard-banner-1.png"

function AllCategoryBanner() {
    return (
        <React.Fragment>
            <Box
                component="img"
                src={Allgiftcardbanner}
                alt="all Category Banner"
                sx={{
                    mb:3,
                    width: '100%',
                    objectFit: 'contain',
                    height: 'auto',
                }}
            />
        </React.Fragment>
    );
}

export default AllCategoryBanner;
